import React from 'react';

import Card from '/component/base/Card';
import {Rank} from '/constant/TestIDs';

import Detail from './Detail';
import {PersonalRankSummary} from './PersonalRankSummary';
import ProgressBar from './ProgressBar';
import {styles} from './RankProgressCard.style';
import Summary from './Summary';

interface RankProgressCardProps {
  style: {base: object; title: object};
  coachId: number | null;
  hasNextRank: boolean;
  onSummaryPress: () => void;
  showDetailedProgress: boolean;
}

export const RankProgressCard: React.FC<RankProgressCardProps> = ({
  style: styleProp = {base: {}, title: {}},
  coachId = null,
  hasNextRank = true,
  onSummaryPress = () => {},
  showDetailedProgress = false,
}: RankProgressCardProps) => {
  const style = {
    ...styles.base,
    // When the detail section is not shown, we want `base`
    // set `overflow: hidden` on `base` 'causing the bottom
    // corners of the progress bar to be rounded off.
    // When the detail section is shown, we don't want to
    // set `overflow: hidden` on `base` because the detail
    // section needs shadow and having`overflow: hidden` on
    // `base` would prevent detail section's shadow from
    // being visible.
    ...(showDetailedProgress && hasNextRank
      ? {}
      : styles.baseWithRoundedBottom),
    ...(styleProp.base || {}),
  };

  return (
    <Card hasBorder={false} testID={Rank.rankProgressCard} style={style}>
      {showDetailedProgress ? (
        <Summary coachId={coachId} />
      ) : (
        <PersonalRankSummary coachId={coachId} onPress={onSummaryPress} />
      )}
      <ProgressBar coachId={coachId} />
      {hasNextRank && showDetailedProgress && (
        <Detail coachId={coachId} hasShadow={true} />
      )}
    </Card>
  );
};

export default RankProgressCard;
